module.exports = __webpack_public_path__ + "static/woman-tablet-square.950b9317.jpg";